import "@material-symbols/font-700/rounded.css";
import materialSymbolsFont from "@material-symbols/font-700/material-symbols-rounded.woff2";
const preloadIconFont = () => {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "font";
  link.type = "font/woff2";
  link.href = materialSymbolsFont;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
};
preloadIconFont();
